import React from "react";
import { useTranslation } from "react-i18next";

import { ResultsTable } from "./ResultsTable";
import { usePlacesQuery, usePlacesQueryResults } from "../hooks";
import { StatusBadge } from "../QueriesList/StatusBadge";

import "./styles.scss";

export interface IQueryDetailProps {
  queryId: string;
  onBack: () => void;
}

export const QueryDetail: React.FunctionComponent<IQueryDetailProps> = ({
  queryId,
  onBack,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params?: { [key: string]: string | number }) =>
    _t(`internalToolsHomePage.gbp_places_query.detail.${key}`, params);

  const { data: detail } = usePlacesQuery(queryId);
  const {
    query: resultsQuery,
    searchParams,
    setSearchParams,
    filterFormData,
    handleChangeFilterFormData,
  } = usePlacesQueryResults(queryId, detail?.status === "pending");

  return (
    <section className="white-border-panel padding32 gbp-places-query-detail">
      <button
        type="button"
        className="back-link gbp-places-query-detail-back"
        onClick={onBack}
      >
        <i className="icons icon-back"></i>
        {t("back")}
      </button>
      {detail && (
        <>
          <div className="gbp-places-query-detail-header">
            <h3>{detail.name}</h3>
            <StatusBadge
              status={detail.status}
              errorMessage={detail.error_message}
            />
          </div>
          <p className="gbp-places-query-detail-area">
            {detail.prefecture?.name}
            {detail.city
              ? ` ${detail.city.name}`
              : ` ${t("area_whole_prefecture")}`}
          </p>
          {detail.status === "failed" && detail.error_message && (
            <p className="gbp-places-query-detail-banner banner-error">
              {detail.error_message}
            </p>
          )}
          {detail.status === "completed" && detail.error_message && (
            <p className="gbp-places-query-detail-banner banner-info">
              {t("quota_note")}
            </p>
          )}
          <ResultsTable
            results={resultsQuery.data?.data ?? []}
            totalCount={
              resultsQuery.data?.count ?? detail._count?.results ?? 0
            }
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            filterFormData={filterFormData}
            onChangeFilterFormData={handleChangeFilterFormData}
          />
        </>
      )}
    </section>
  );
};

export default QueryDetail;
